/* ═══ AgDivider — Anagogia Design System ═══ */

import styles from './AgDivider.module.css';

interface AgDividerProps {
  /** Direction of the divider line */
  orientation?: 'horizontal' | 'vertical';
  className?: string;
}

/**
 * Séparateur horizontal ou vertical.
 * @category Affichage
 */
function AgDivider({
  orientation = 'horizontal',
  className,
}: AgDividerProps) {
  if (orientation === 'vertical') {
    return (
      <div
        className={[styles.vertical, className].filter(Boolean).join(' ')}
        role="separator"
        aria-orientation="vertical"
      />
    );
  }

  return (
    <hr
      className={[styles.horizontal, className].filter(Boolean).join(' ')}
      role="separator"
      aria-orientation="horizontal"
    />
  );
}

export { AgDivider };
export type { AgDividerProps };
export default AgDivider;
